import { createDefaultTyrann } from '@apis/common';
import * as t from 'io-ts';

export const zipCodeCity = t.type({
  zipcode: t.string,
  city: t.string,
  province: t.string,
  city_zh: t.string,
  province_zh: t.string,
});

export type ZipCodeCity = t.TypeOf<typeof zipCodeCity>;

export const zipCodeCityApis = createDefaultTyrann({
  '/zipcode-city/city/{zipcode}/': {
    get: {
      path: t.type({
        zipcode: t.string,
      }),
      response: {
        200: t.array(zipCodeCity),
      },
    },
  },
  '/zipcode-city/zipcode/{city}/': {
    get: {
      path: t.type({
        city: t.string,
      }),
      query: t.partial({
        enable_zh: t.boolean,
      }),
      response: {
        200: t.array(zipCodeCity),
      },
    },
  },
});
